import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewListInfoText } = listModuleLenses

export default (state, { moduleId }) => viewListInfoText(moduleId, moduleDescriptions)
